import type { CSSProperties, Ref } from 'react';
import type { ImageTeaserType } from './types';

/**
 * ImageTeaser Helper Functions
 *
 * Teaser-specific data extraction and fallback rendering. Dimensions, source URLs, sizes and the optimized
 * rendering are shared with CmsImage in `../CmsImage/CmsImageItem.helpers`.
 */

// ==================== DATA EXTRACTION ====================

/**
 * Extracts image objects from ImageTeaser data.
 * Returns desktop and mobile image variants.
 */
export const extractImageTeaserObjects = (data: ImageTeaserType) => ({
  imageObjDefault: data.image_default ?? null,
  imageObjMobile: data.image_mobile ?? null,
});

// ==================== RENDERING ====================

/**
 * Renders a simple fallback image without optimization.
 * Used for images without dimensions.
 */
export const FallbackImageTeaser = ({
  ref,
  defaultSrc,
  altText,
  lazyLoading,
  className,
  style,
}: {
  ref: Ref<HTMLImageElement>;
  defaultSrc: string;
  altText: string;
  lazyLoading: boolean;
  className?: string;
  style?: CSSProperties;
}) => (
  <img
    ref={ref}
    src={defaultSrc}
    alt={altText}
    loading={lazyLoading ? 'lazy' : 'eager'}
    className={className}
    style={style}
  />
);
